<script>
import {mapState,mapMutations} from 'vuex'

import ArrayUtil from './utilities/ArrayUtil'
import BrowserDataUtil from './utilities/BrowserDataUtil'

export default {
	name: 'AuthGuard',
	computed : {
		...mapState({
            profile : "userProfile"
        })
	},
	created(){
		this.checkProfile();
	},
	methods: {
		...mapMutations({
            setProfile : "updateUserProfile",
            clearAppData : "clearAppData"
		}),
		checkProfile(){
			var user = BrowserDataUtil.getBrowserData(
				this.$cookies,
				'ore-user-profile',
				this.profile
			);
			if (user==null) {
				this.logOut();
				return false;
			}
			// Set store data
			this.setProfile(user);
			// Set browser data
            BrowserDataUtil.setProfile(this.$cookies,user);
		},
        logOut(){
            this.clearAppData();
            this.$router.push({path:"/login"})
        }
	}
}
</script>

<template>
	<div class="base-box box-hw--fill app-body">
		<router-view/>
	</div>
</template>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

$primary : #092257;
$primary-invert : findColorInvert($primary);

$turqoise-blue : #00ffe7;
$tb-invert : findColorInvert($turqoise-blue);

$rust : #af3800;
$rust-invert : findColorInvert($rust);

$deep-saffron : #fa9f42;
$ds-invert : findColorInvert($deep-saffron);

$indigo-dye : #2b4162;
$id-invert : findColorInvert($indigo-dye);

$cadet-blue : #51a3a3;
$cb-invert : findColorInvert($cadet-blue);

$french-lilac : #8d6a9f;
$fl-invert : findColorInvert($french-lilac);

$gg-orange : #bb342f;
$go-invert : findColorInvert($gg-orange);

$army-green : #41521f;
$ag-invert : findColorInvert($army-green);

$russian-violet : #231651;
$rv-invert : findColorInvert($russian-violet);

$spanish-blue : #2374ab;
$sb-invert : findColorInvert($spanish-blue);

$claret : #89043d;
$claret-invert : findColorInvert($claret);

$mining : #00d1b2;
$mining-invert: findColorInvert($mining);

$oilgas : #ca7e0c;
$oilgas-invert: findColorInvert($oilgas);

$colors: (
	"white" : ($white,$black),
	"black" : ($black,$white),
	"light" : ($light,$light-invert),
	"dark" : ($dark,$dark-invert),
	"info" : ($info,$info-invert),
	"success" : ($success,$success-invert),
	"warning" : ($warning,$warning-invert),
	"danger" : ($danger,$danger-invert),
	"turqoise-blue" : ($turqoise-blue, $tb-invert ),
	"rust" : ($rust, $rust-invert),
	"deep-saffron" : ($deep-saffron, $ds-invert),
	"indigo-dye" : ($indigo-dye,$id-invert),
	"cadet-blue": ($cadet-blue,$cb-invert),
	"french-lilac": ($french-lilac,$fl-invert),
	"gg-orange": ($gg-orange,$go-invert),
	"army-green": ($army-green,$ag-invert),
	"russian-violet":($russian-violet,$rv-invert),
	"spanish-blue": ($spanish-blue,$sb-invert),
	"claret": ($claret,$claret-invert),
	"mining" : ($mining,$mining-invert),
	"oilgas" : ($oilgas,$oilgas-invert),
	"dropdown-item-hover-background-color" : ($primary,$white)
);

$link : #209CEE;
$link-invert : $primary-invert;
$link-focus-border: $primary;

@import "~bulma";
@import "~buefy/src/scss/buefy";
@import 'bulma-tooltip/dist/css/bulma-tooltip.min.css';
@import 'bulma-divider/dist/css/bulma-divider.min.css';
@import 'bulma-timeline/dist/css/bulma-timeline.min.css';
@import 'assets/css/style.css';
</style>



// WEBPACK FOOTER //
// src/AuthGuard.vue